import { ButtonVariant } from '@sato/components';
import { flatten } from 'lodash';

import {
  EntryType,
  ILinkButtonFields,
  IRichTextFields,
  ParsedEntry,
} from '../types';

export const linkButtonVariantMap: Record<
  NonNullable<ILinkButtonFields['variant']> | 'no variant',
  ButtonVariant | undefined
> = {
  text: 'text',
  contained: 'filled',
  outlined: 'outlined',
  'no variant': undefined,
};

/** filter all fields of an entry that include entries as children */
export const getSubEntryFields = (obj: ParsedEntry<EntryType>): any =>
  flatten(
    Object.values(obj).filter((field) => {
      const fieldValue = Array.isArray(field) ? field[0] : field;
      return typeof fieldValue === 'object';
    })
  );

/**
 * Check recursively if an entry with the give entry ID is included
 * in the given array of entries or in any of their subfields
 */
export const includesEntry = (
  entries: ParsedEntry<EntryType>[] | undefined,
  entryId: string
): boolean => {
  if (!entries || entries.length === 0) return false;

  return entries.some(
    (entry) =>
      entry.id === entryId || includesEntry(getSubEntryFields(entry), entryId)
  );
};
/** Map Contentful text-align options to Tailwind classes that align the text accordingly */
export const textAlignMap: Record<
  NonNullable<IRichTextFields['textPosition']>,
  string
> = {
  inherit: 'text-inherit',
  left: 'text-left',
  right: 'text-right',
  center: 'text-center',
};

export const getContentfulLinkAnalyticsProps = (
  analyticsId: string | undefined
) => ({
  analytics: analyticsId
    ? { linkContext: analyticsId, contentContext: 'contentful' }
    : undefined,
});
